import axios from 'axios'
import api from './api'
import Vue from 'vue';
let Base64 = require('js-base64').Base64;
import { Toast } from 'vant';
import qs from "qs";

Vue.use(Toast);

// 开发环境走本地代理，解决 localhost 跨域 cookie / 轮播语言问题
const isDev = process.env.NODE_ENV === 'development';
export const API_BASE = isDev ? '/api' : 'https://api.652795.shop/api';
export const ASSET_ORIGIN = 'https://api.652795.shop';

/** 把后台相对路径补成可访问的完整图片地址 */
export function resolveAssetUrl(url) {
  if (!url) return '';
  const s = String(url).trim();
  if (!s) return '';
  if (/^https?:\/\//i.test(s) || s.startsWith('data:')) return s;
  if (s.startsWith('//')) return 'https:' + s;
  // 兼容 admin 子域静态资源
  if (
    s.startsWith('/xuanfei/') ||
    s.startsWith('xuanfei/') ||
    s.startsWith('/lottery/') ||
    s.startsWith('lottery/')
  ) {
    const path = s.startsWith('/') ? s : '/' + s;
    return 'https://admin.652795.shop' + path;
  }
  return ASSET_ORIGIN + (s.startsWith('/') ? s : '/' + s);
}
//创建axios实例对象
const  instance = axios.create({
    // baseURL: 'https://ui11.kjyss.help/api',
    baseURL: API_BASE,
    timeout: 30000, //默认超时时长
    withCredentials: true, 
})

//请求拦截器
instance.interceptors.request.use(config=>{
    config.headers = {
        ...config.headers,
        'lang': localStorage.getItem("lang") || 'kr',
    }
    if(config.method === "post"){
        config.headers = {
            ...config.headers,
            'content-type': 'application/x-www-form-urlencoded;charset=UTF-8',
        }
    }
    if(localStorage.getItem('token')){
        config.headers = {
            ...config.headers, 
            'token': Base64.encode(localStorage.getItem('token')),
        }
    }
    return config
},err=>{
    console.error('请求失败',err)
})

//响应拦截器
instance.interceptors.response.use(res=>{
    //此处对响应数据做处理
    if(res.data.msg === "鉴权错误"){
        // localStorage.clear();
        // this.$router.push({path:'/Login'})
    }
    return res //该返回对象会传到请求方法的响应对象中
},err=>{
    // 响应错误处理
    return Promise.reject(err);
})

//封装axios请求方法，参数为配置对象
//option = {method,url,params} method为请求方法，url为请求接口，params为请求参数
async function http(option = {}) {
    let result = null
    if(option.method === 'get' || option.method === 'delete'){
        //处理get、delete请求
        await instance[option.method](
            api[option.url],
            {params: option.data}
        ).then(res=>{
            result = res.data
            result.data = JSON.parse(Base64.decode(result.data));
        }).catch(err=>{
            result = err
        })
    }else if(option.method === 'post' || option.method === 'put'){
        //处理post、put请求
        await instance[option.method](
                api[option.url],
            qs.stringify(option.data)
        ).then(res=>{
            result = res.data;
            result.data = JSON.parse(Base64.decode(result.data));
        }).catch(err=>{
            result = err
        })
    }
    return result
}

export default http
export { http }
